export default __webpack_public_path__ + "static/media/health.e05d2643.yaml";